import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const [currentTime, setCurrentTime] = useState("");
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [notifications, setNotifications] = useState([
    { id: 1, text: "لديك 5 طلبات جديدة", time: "منذ 10 دقائق", read: false },
    { id: 2, text: "تم تحديث نظام الدفع", time: "منذ ساعة", read: false },
    { id: 3, text: "اجتماع مهم غداً", time: "منذ يوم", read: true }
  ]);
  const navigate = useNavigate();

  // تحديث الوقت الحالي
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const timeString = now.toLocaleTimeString('ar-SA', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
      setCurrentTime(timeString);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  // تسجيل الخروج
  const handleLogout = () => {
    // يمكن إضافة منطق تسجيل الخروج هنا
    localStorage.removeItem('academy_token');
    navigate('/academy-login');
  };

  // أيقونات SVG
  const AcademyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "28px", height: "28px" }}>
      <path d="M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912.75.75 0 01-.584 0A49.87 49.87 0 002 9.268a.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z" />
      <path d="M13.06 15.473a48.45 48.45 0 017.666-3.282c.134 1.414.22 2.843.255 4.285a.75.75 0 01-.46.71 47.878 47.878 0 00-8.105 4.342.75.75 0 01-.832 0 47.877 47.877 0 00-8.104-4.342.75.75 0 01-.461-.71c.035-1.442.121-2.87.255-4.286A48.4 48.4 0 016 13.18v1.27a1.5 1.5 0 00-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.661a6.729 6.729 0 00.551-1.608 1.5 1.5 0 00.14-2.67v-.645a48.549 48.549 0 013.44 1.668 2.25 2.25 0 002.12 0z" />
    </svg>
  );

  const BellIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
      <path fillRule="evenodd" d="M5.25 9a6.75 6.75 0 0113.5 0v.75c0 2.123.8 4.057 2.118 5.52a.75.75 0 01-.297 1.206c-1.544.57-3.16.99-4.831 1.243a3.75 3.75 0 11-7.48 0 24.585 24.585 0 01-4.831-1.244.75.75 0 01-.298-1.205A8.217 8.217 0 005.25 9.75V9zm4.502 8.9a2.25 2.25 0 104.496 0 25.057 25.057 0 01-4.496 0z" clipRule="evenodd" />
    </svg>
  );

  const UserIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "22px", height: "22px" }}>
      <path fillRule="evenodd" d="M7.5 6a4.5 4.5 0 119 0 4.5 4.5 0 01-9 0zM3.751 20.105a8.25 8.25 0 0116.498 0 .75.75 0 01-.437.695A18.683 18.683 0 0112 22.5c-2.786 0-5.433-.608-7.812-1.7a.75.75 0 01-.437-.695z" clipRule="evenodd" />
    </svg>
  );

  const LogoutIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "18px", height: "18px" }}>
      <path fillRule="evenodd" d="M7.5 3.75A1.5 1.5 0 006 5.25v13.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V15a.75.75 0 011.5 0v3.75a3 3 0 01-3 3h-6a3 3 0 01-3-3V5.25a3 3 0 013-3h6a3 3 0 013 3V9a.75.75 0 01-1.5 0V5.25a1.5 1.5 0 00-1.5-1.5h-6zm10.72 4.72a.75.75 0 011.06 0l3 3a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l1.72-1.72H9a.75.75 0 010-1.5h10.94l-1.72-1.72a.75.75 0 010-1.06z" clipRule="evenodd" />
    </svg>
  );

  const SettingsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "18px", height: "18px" }}>
      <path fillRule="evenodd" d="M12 6.75a5.25 5.25 0 016.775-5.025.75.75 0 01.313 1.248l-3.32 3.319c.063.475.276.934.641 1.299.365.365.824.578 1.3.64l3.318-3.319a.75.75 0 011.248.313 5.25 5.25 0 01-5.472 6.756c-1.018-.086-1.87.1-2.309.634L7.344 21.3A3.298 3.298 0 112.7 16.657l8.684-7.151c.533-.44.72-1.291.634-2.309A5.342 5.342 0 0112 6.75zM4.117 19.125a.75.75 0 01.75-.75h.008a.75.75 0 01.75.75v.008a.75.75 0 01-.75.75h-.008a.75.75 0 01-.75-.75v-.008z" clipRule="evenodd" />
    </svg>
  );

  // تنسيقات CSS
  const styles = {
    header: {
      backgroundColor: "white",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.08)",
      padding: "0 25px",
      position: "sticky",
      top: "0",
      zIndex: "1000",
      borderBottom: "1px solid #f0f0f0"
    },
    headerContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "70px"
    },
    logoSection: {
      display: "flex",
      alignItems: "center",
      gap: "15px"
    },
    logo: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      textDecoration: "none",
      color: "inherit"
    },
    logoIcon: {
      width: "40px",
      height: "40px",
      background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
      borderRadius: "10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    logoText: {
      display: "flex",
      flexDirection: "column"
    },
    academyName: {
      margin: "0",
      fontSize: "20px",
      fontWeight: "700",
      color: "#182848",
      lineHeight: "1.2"
    },
    academySubtitle: {
      margin: "0",
      fontSize: "12px",
      color: "#6c757d",
      fontWeight: "500"
    },
    timeSection: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#f8f9fa",
      padding: "8px 15px",
      borderRadius: "10px",
      minWidth: "120px"
    },
    timeTitle: {
      margin: "0",
      fontSize: "12px",
      color: "#6c757d",
      fontWeight: "500",
      marginBottom: "3px"
    },
    timeValue: {
      margin: "0",
      fontSize: "16px",
      fontWeight: "600",
      color: "#182848",
      fontFamily: "'Courier New', monospace"
    },
    actionsSection: {
      display: "flex",
      alignItems: "center",
      gap: "20px"
    },
    notificationIcon: {
      position: "relative",
      cursor: "pointer",
      padding: "8px",
      borderRadius: "8px",
      transition: "all 0.3s"
    },
    notificationBadge: {
      position: "absolute",
      top: "-5px",
      right: "-5px",
      backgroundColor: "#dc3545",
      color: "white",
      fontSize: "10px",
      fontWeight: "bold",
      width: "18px",
      height: "18px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    unreadCount: {
      backgroundColor: "#dc3545",
      color: "white",
      fontSize: "11px",
      fontWeight: "bold",
      padding: "2px 6px",
      borderRadius: "10px",
      marginLeft: "5px"
    },
    userSection: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      gap: "10px",
      cursor: "pointer",
      padding: "8px 12px",
      borderRadius: "10px",
      transition: "all 0.3s",
      backgroundColor: "#f8f9fa"
    },
    userInfo: {
      display: "flex",
      flexDirection: "column"
    },
    userName: {
      margin: "0",
      fontSize: "14px",
      fontWeight: "600",
      color: "#182848"
    },
    userRole: {
      margin: "0",
      fontSize: "12px",
      color: "#6c757d"
    },
    userMenu: {
      position: "absolute",
      top: "100%",
      right: "0",
      backgroundColor: "white",
      boxShadow: "0 5px 15px rgba(0, 0, 0, 0.1)",
      borderRadius: "10px",
      width: "200px",
      marginTop: "10px",
      overflow: "hidden",
      border: "1px solid #f0f0f0"
    },
    menuItem: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      padding: "12px 15px",
      color: "#495057",
      textDecoration: "none",
      transition: "all 0.3s",
      borderBottom: "1px solid #f8f9fa",
      backgroundColor: "white",
      cursor: "pointer",
      fontSize: "14px"
    },
    menuDivider: {
      height: "1px",
      backgroundColor: "#f0f0f0",
      margin: "0"
    },
    // تأثيرات hover
    hoverEffect: {
      backgroundColor: "#f8f9fa",
      transform: "translateY(-1px)"
    },
    activeEffect: {
      backgroundColor: "#4b6cb7",
      color: "white"
    }
  };

  // حساب الإشعارات غير المقروءة
  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <header style={styles.header}>
      <div style={styles.headerContainer}>
        {/* القسم الأيسر: الشعار */}
        <div style={styles.logoSection}>
          <a href="/academy-admin" style={styles.logo}>
            <div style={styles.logoIcon}>
              <AcademyIcon />
            </div>
            <div style={styles.logoText}>
              <h3 style={styles.academyName}>لوحة تحكم الأكاديمية</h3>
              <p style={styles.academySubtitle}>نظام إدارة التعليم الإلكتروني</p>
            </div>
          </a>
        </div>

        {/* القسم الأوسط: الوقت والتاريخ */}
        <div style={styles.timeSection}>
          <p style={styles.timeTitle}>التوقيت الحالي</p>
          <p style={styles.timeValue}>{currentTime}</p>
        </div>

        {/* القسم الأيمن: الإجراءات والمستخدم */}
        <div style={styles.actionsSection}>
          {/* أيقونة الإشعارات */}
          <div 
            style={styles.notificationIcon}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}
            onClick={() => {
              // يمكن إضافة منطق عرض الإشعارات هنا
              alert("صفحة الإشعارات قريباً!");
            }}
          >
            <BellIcon />
            {unreadCount > 0 && (
              <span style={styles.notificationBadge}>
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </div>

          {/* قسم المستخدم */}
          <div 
            style={styles.userSection}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e9ecef"}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
            onClick={() => setShowUserMenu(!showUserMenu)}
          >
            <UserIcon />
            <div style={styles.userInfo}>
              <p style={styles.userName}>مدير الأكاديمية</p>
              <p style={styles.userRole}>Admin</p>
            </div>
            
            {/* قائمة المستخدم */}
            {showUserMenu && (
              <div style={styles.userMenu}>
                <div 
                  style={styles.menuItem}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                  onClick={() => {
                    // يمكن إضافة منطق الإعدادات هنا
                    alert("صفحة الإعدادات قريباً!");
                  }}
                >
                  <SettingsIcon />
                  الإعدادات
                </div>
                
                <hr style={styles.menuDivider} />
                
                <div 
                  style={styles.menuItem}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#f8f9fa"}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "white"}
                  onClick={handleLogout}
                >
                  <LogoutIcon />
                  تسجيل الخروج
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* إضافة أنيميشن للقوائم المنسدلة */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .user-menu {
          animation: fadeIn 0.2s ease-out;
        }
        
        @media (max-width: 768px) {
          .header-container {
            flex-direction: column;
            height: auto;
            padding: 15px 0;
            gap: 15px;
          }
          
          .time-section {
            order: 3;
            width: 100%;
            margin-top: 10px;
          }
        }
      `}</style>
    </header>
  );
}